<template>
    <div class="site-wrapper loginPageWrap">
        <header>
            <div class="wrap">
                <div class="container">
					<a href="https://www.vuelo.com/"><img src="/assets/img/logo_transparent.svg" alt="logo" class="logo"></a>

                    <LanguageSwitcher />
                </div>
            </div>
        </header>
        <main>
            <router-view />
        </main>

        <footer v-if="$mq=='lg'">
            <div class="resize">
                <div>
                    <ul class="socials">
                        <li>
                            <a href="https://www.facebook.com/flynowpaylatertravel/" target="_blank">
                                <i class="fa fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/vuelouk" target="_blank">
                                <i class="fa fa-twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/flynowpaylatertravel/" target="_blank">
                                <i class="fa fa-instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/getvuelo-co-uk/" target="_blank">
                                <i class="fa fa-linkedin"></i>
                            </a>
                        </li>
                    </ul>
                    <p class="copyright">
                        <span class="block">Copyright &copy; 2020</span>
                         <a v-bind:href="websiteMainLink">Vuelo.com</a>
                    </p>
                </div>

            </div>

        </footer>
    </div>


</template>

<script>

    import LanguageSwitcher from '../components/common/LanguageSwitcher';


    export default {
        components: {LanguageSwitcher},
		data() {
        	return {
				websiteMainLink: window.mainWebsiteLink
			}
		},

        created() {
        },

    }
</script>
